import { render } from "./MerchantCredits.vue?vue&type=template&id=bbdc6772&scoped=true"
import script from "./MerchantCredits.vue?vue&type=script&lang=js"
export * from "./MerchantCredits.vue?vue&type=script&lang=js"

import "./MerchantCredits.vue?vue&type=style&index=0&id=bbdc6772&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbdc6772"]])

export default __exports__